import React from 'react';
import { useTranslation } from 'react-i18next';

import * as Text from 'theme/components/Text.style';
import * as Styled from 'events/styles/EmptyActivityOnboarding.style';

const WaveformSvg = (): JSX.Element => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <rect x="1" y="9" width="2" height="4" rx="1" fill="currentColor" />
    <rect x="5" y="6" width="2" height="10" rx="1" fill="currentColor" />
    <rect x="9" y="2" width="2" height="18" rx="1" fill="currentColor" />
    <rect x="13" y="6" width="2" height="10" rx="1" fill="currentColor" />
    <rect x="17" y="9" width="2" height="4" rx="1" fill="currentColor" />
  </svg>
);

const PROMPT_KEYS = [
  'emptyActivityOnboarding.prompts.attendancePolicy',
  'emptyActivityOnboarding.prompts.understaffed',
  'emptyActivityOnboarding.prompts.warningLetter',
] as const;

export default function EmptyActivityOnboarding(): JSX.Element {
  const { t } = useTranslation('pageEvents');

  return (
    <Styled.Card>
      <Styled.TextBlock>
        <Text.H5>{t('emptyActivityOnboarding.title')}</Text.H5>
        <Styled.Subtitle>
          {t('emptyActivityOnboarding.subtitle')}
        </Styled.Subtitle>
      </Styled.TextBlock>
      <Styled.PromptList>
        {PROMPT_KEYS.map((key) => (
          <Styled.PromptItem key={key}>
            <Styled.WaveformIcon>
              <WaveformSvg />
            </Styled.WaveformIcon>
            <Text.P2Bold>{t(key)}</Text.P2Bold>
          </Styled.PromptItem>
        ))}
      </Styled.PromptList>
    </Styled.Card>
  );
}
